import React from 'react'

const SlideOne = () => (
  <div className="slide">
    <div className="slide-inner">
      <div className="slide-left">
        <h2>Why ZERO?</h2>
        <p>
          The ZERO Exchange Protocol realigns incentives for network participants by introducing revenue sharing and community driven network effects to the popular AMM model.
        </p>
        <p>
        Avalanche achieves sub-second transaction finality, supports Visa- level transaction throughput, is resilient to 51% attacks, and is the only blockchain that supports multiple virtual machines. Following the success of Uniswap and its fork Sushiswap, ZERO Exchange is built with the help
of Santa and his helpers. Open Source Repo located on Github.
        </p>
      </div>
      <div className="slide-right">

      <h3>ZERO Fees</h3>
      <p>Utilizing the Avalanche (AVAX) Blockchain, ZERO Exchange offers its users a fee free trading experience. Gone are the days of gas wars and absurd transaction fees!</p>
      <h3>ZERO Finality</h3>
      <p>Successful trading relies on quick reaction time, now you have an exchange that gives you the speed necessary to trade in harmony with the market. ZERO features sub second block times with
near instantaneous transaction confirmation (120% faster than Ethereum).</p>
      <h3>ZERO Hassle</h3>
      <p>Simply connect your Web3 enabled wallet to begin trading, staking, and farming your favorite pairs!</p>

      </div>
    </div>
  </div>
)

export default SlideOne
